import { useEffect, useState } from 'react';
import { fetchSiteContent, sectionOr } from '../utils/siteContent';

const useData = () => {
  const [loadData, setLoadData] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const resp = await fetch('/fakedata/healthcaredb.json'); // see note below about path
        await resp.json();
  setLoadData([
  {
    id: 1,
    treatment: "Claw Machines",
    slug: "claw-machines",
    iconKey: "claw",
    component: "ClawMachines",
    service_img: "/clawmachines/cover-1600.jpg",
    service_img_srcset: "/clawmachines/cover-960.jpg 960w, /clawmachines/cover-1600.jpg 1600w",
    service_img_sizes: "(max-width: 960px) 100vw, 1200px",
  },
  {
    id: 2,
    treatment: "Photobooth",
    slug: "photobooth",
    iconKey: "photobooth",
    component: "Photobooth",
    service_img: "/banner/2-1600.jpg",
    service_img_srcset: "/banner/2-960.jpg 960w, /banner/2-1600.jpg 1600w",
    service_img_sizes: "(max-width: 960px) 100vw, 1200px",
  },
  {
    id: 3,
    treatment: "Memberships",
    slug: "memberships",
    iconKey: "membership",
    component: "Memberships",
    service_img: "/memberships/cover-1600.jpg",
    service_img_srcset: "/memberships/cover-960.jpg 960w, /memberships/cover-1600.jpg 1600w",
    service_img_sizes: "(max-width: 960px) 100vw, 1200px",
  },
  {
    id: 4,
    treatment: "Artist Alley",
    slug: "artist-alley",
    iconKey: "artist",
    component: "ArtistAlley",
    service_img: "/artistalley/cover.jpg",
  },
  {
    id: 5,
    treatment: "Leaderboard",
    slug: "leaderboard",
    iconKey: "leaderboard",
    component: "Leaderboard",
    service_img: "/leaderboard/cover.jpg",
  },
  {
    id: 6,
    treatment: "Gift Cards",
    slug: "gift-cards",
    iconKey: "giftcards",
    component: "GiftCards",
    service_img: "/giftcards/cover-1600.jpg",
    service_img_srcset: "/giftcards/cover-960.jpg 960w, /giftcards/cover-1600.jpg 1600w",
    service_img_sizes: "(max-width: 960px) 100vw, 1200px",
  },
  {
    id: 7,
    treatment: "Events",
    slug: "events",
    iconKey: "events",
    component: "Events",
    service_img: "/events/birthdays/cover-1600.jpg",
    service_img_srcset: "/events/birthdays/cover-960.jpg 960w, /events/birthdays/cover-1600.jpg 1600w",
    service_img_sizes: "(max-width: 960px) 100vw, 1200px",
  },
  {
    id: 8,
    treatment: "Rentals",
    slug: "rentals",
    iconKey: "rentals",
    component: "Rentals",
    service_img: "/rentals/cover.jpg",
  },
  {
    id: 9,
    treatment: "Pop-Ups",
    slug: "pop-ups",
    iconKey: "popups",
    component: "PopUps",
    // Placeholder cover (a past food pop-up) — swap for /popups/cover-1600.jpg
    // once a dedicated photo is added to public/popups/.
    service_img: "/events/spoonmii/cover.jpg",
  },
]);
             // set the array you want
      } catch (err) {
        console.error('fetch error', err);
      }
    }
    fetchData();
  }, []);

  // Section covers the owner has replaced from the admin app. Anything they
  // haven't set keeps the image the site ships with, so a partial list is fine.
  useEffect(() => {
    let cancelled = false;
    fetchSiteContent().then((content) => {
      if (cancelled) return;
      const overrides = sectionOr(content, 'serviceImages', null);
      if (!overrides) return;

      const bySlug = new Map(
        overrides.filter((o) => o.slug && o.imageUrl).map((o) => [o.slug, o.imageUrl])
      );
      if (bySlug.size === 0) return;

      setLoadData((prev) =>
        prev.map((service) => {
          const url = bySlug.get(service.slug);
          if (!url) return service;
          return {
            ...service,
            service_img: url,
            // Drop the hand-cut srcset — it points at the old files, and
            // leaving it would override the new image on wide screens.
            service_img_srcset: undefined,
          };
        })
      );
    });
    return () => { cancelled = true; };
  }, []);

  return loadData; // or just return loadData if you prefer
};

export default useData;
